module.exports = __webpack_public_path__ + "static/media/srsimage.b67105ef.png";